<script>
    import QRCodeStyling from "qr-code-styling";
    import chroma from "chroma-js";

    import { onMount } from "svelte";

    export let demoncode;    
    let qrCanvas;
    let qrDataURL;
    let qrCode;
    let baseColor = "#000000";
    export let qrSize = 200;

    onMount(() => {
        // console.log("mounted");

        baseColor = chroma(parseDemon(demoncode)['baseColor']).darken(3);

        qrCode = new QRCodeStyling({
            width: qrSize,
            height: qrSize,
            data: "https://demons.johndilworth.com/#/" + demoncode,
            dotsOptions: {
                color: baseColor,
                type: "rounded",
            },
            cornersSquareOptions: {
                type: "dot",
                color: chroma(baseColor).brighten(1),
            },
            cornersDotOptions: {
                type: "dot",
                color: chroma(baseColor).brighten(2),
            },
            backgroundOptions: {
                color: "#ffffff",
            },
            imageOptions: {
                crossOrigin: "anonymous",
                margin: 0,
                imageSize: 0.5,
            },
        });
        qrCode.append(qrCanvas);
        var theCode = document.querySelectorAll('.qr canvas')
        qrDataURL = theCode[0].toDataURL();
     
    });

    function parseDemon(demoncode) {
		var color = demoncode.split("-")[1];
        var fname = demoncode.split("-")[2];
        var lname = demoncode.split("-")[3];
		var code = demoncode.split("");
		//chin+ear+face+paint+mouth+tongue+horn+eye+nose+hair;
		
		// console.log("color:#" + color);
		// console.log("demoncode:" + demoncode);
		return {
			demoncode: demoncode,
			baseColor: "#" + color,
			chin: code[0],
			ear: code[1],
			face: code[2],
			paint: code[3],
			mouth: code[4],			
			horn: code[5],
			eye: code[6],
			nose: code[7],
			hair: code[8],
			bgcode: code[9],
            sleeping: code[10],
            fname: fname,
            lname: lname
		};
	}
</script>

<image xlink:href="{qrDataURL}" width="{qrSize}" height="{qrSize}" />

<div class="qr" bind:this={qrCanvas} />


<style>
    .qr{
        display: none;
    }
</style>
